/* French initialisation for the jQuery UI date picker plugin. */
/* Written by Keith Wood (kbwood{at}iinet.com.au),
			  StÃ©phane Nahmani (sholby@sholby.net),
			  StÃ©phane Raimbault <stephane.raimbault@gmail.com> */
(function( factory ) {
	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define([ "../jquery.ui.datepicker" ], factory );
	} else {

		// Browser globals
		factory( jQuery.datepicker );
	}
}(function( datepicker ) {
	datepicker.regional['sl'] = {
		closeText: 'Zapri',
		prevText: 'Nazaj',
		nextText: 'Naprej',
		currentText: 'Trenutno',
		monthNames: ['januar', 'februar', 'marec', 'april', 'maj', 'junij',
			'julij', 'avgust', 'september', 'oktober', 'november', 'december'],
		monthNamesShort: ['jan', 'fen', 'mar', 'apr', 'maj', 'jun',
			'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
		dayNames: ['nedelja', 'ponedeljek', 'torek', 'sreda', 'četrtek', 'petek', 'sobota'],
		dayNamesShort: ['ned', 'pon', 'tor', 'sre', 'čet', 'pet', 'sob'],
		dayNamesMin: ['N','P','T','S','Č','P','So'],
		weekHeader: 'Ted.',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	datepicker.setDefaults(datepicker.regional['sl']);

	return datepicker.regional['sl'];
}));
